import Lottie from 'lottie-react'
import React, { useContext } from 'react'
import intro from '@/assets/lottie/logo_animation_intro.json'
import { context } from '../../../Layout'
import { AnimatePresence, motion } from 'framer-motion'
import './styles.scoped.scss'

export default function SiteIntro() {
  const { setIntroComplete, introShown } = useContext(context)

  const lottieCompleted = () => {
    // setTimeout(() => {
    setIntroComplete()
    // }, 100)
  }

  return (
    <AnimatePresence>
      {!introShown && (
        <motion.div
          key="intro"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="w-screen h-screen transition-opacity max-h-screen overflow-hidden max-w-full absolute top-0 intro-bg left-0 z-[990] flex items-center justify-center"
        >
          <motion.div
            key="intro"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Lottie
              className="!h-auto w-full lg:!w-[780px]"
              animationData={intro}
              loop={false}
              onComplete={() => lottieCompleted()}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
